// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1YNGv","label":"styles_label__1DBlF"};